<template>
  <card>
    <template v-slot:default>
      <div class="properties">
        <property :name="'סוג מנוי'" :value="'מנוי לא פעיל'"/>
        <property :name="'סיום תקופת הניסיון'" :value="trialEndDateFormatted"/>
        <div class="promo-notification-box-container">
          <benefit-notification-box/>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="subscribe-button-container">
        <riseup-button class="subscribe-button" :action="subscribeClicked" :size="'slim'"
                       :title="'הרשמה עם כרטיס אשראי'"/>
      </div>
    </template>
  </card>
</template>

<script>
import BaseUI from 'base-ui';
import { mapState } from 'vuex';
import BenefitNotificationBox from './components/BenefitNotificationBox.vue';
import dates from '../../../../../utils/dates';
import Property from './Property.vue';
import SubscribeClickHandler from './SubscribeClickHandler.vue';

export default {
  name: 'DormantAfterTrialSettings',
  components: {
    Property,
    RiseupButton: BaseUI.RiseupButton,
    BenefitNotificationBox,
    Card: BaseUI.Card,
  },
  mixins: [SubscribeClickHandler],
  computed: {
    ...mapState('subscriptionState', ['since']),
    trialEndDateFormatted() {
      return dates.longHebrewDateFormat(this.since);
    },
  },
};
</script>

<style scoped lang="scss">

  @import "~base-ui/src/scss/riseup-colors";
  @import "./settings";

  @include properties;

  .subscribe-button-container {
    display: flex;
    justify-content: center;
    align-items: center;

    .subscribe-button {
      margin: 23px 0;
      width: 100%;
    }
  }
</style>
